import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, FormGroup, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import Clients from './Clients';
import { BiEnvelope, BiLocationPlus, BiPhoneCall, BiUser } from 'react-icons/bi';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import Loader from '../components/Loader/Loader';

export default function Contact() {
    const [loader, setLoader] = useState(true);
      useEffect(()=>{
setTimeout(()=>{
  setLoader(false);
},2000);
  },[])
    return (
        <>
        {
            loader && <Loader />
        }
            <section className='banner_strip'>

            </section>
            <div className='job-page about-page'>
            <Container fluid style={{padding:0}}>
            <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Contact</li>
            </ol>
            </nav>
            </Container>
                <div className='section-page'>
                    <Container fluid>
                        <Row>
                            <Col lg={12} xs={12}>
                                <h1 className='text-center title-heading op_heading color-dark'>Contact Us</h1>
                            </Col>
                            <Col lg={4} md={4} sm={6} xs={6}>
                                <Card className='service-box contact-box'>
                                    <div className='company-icon'>
                                        <BiLocationPlus />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Address</h4>
                                        <p>Office No.105, 1st Floor, Nawada Printing Press,
                                            Village Naharpur (Kasan), Post Nakhrola,</p>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={4} md={4} sm={6} xs={6}>
                                <Card className='service-box contact-box'>
                                    <div className='company-icon'>
                                        <BiPhoneCall />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Call us</h4>
                                        <p><a href="tel:7982993471;">7982993471</a></p>
                                        <p><a href="tel:8130083757">8130083757</a></p>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={4} md={4} sm={6} xs={6}>
                                <Card className='service-box contact-box'>
                                    <div className='company-icon'>
                                        <BiEnvelope />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Email</h4>
                                        <p><a href="mailto:support@apprenticeshipwale.com">support@apprenticeshipwale.com</a></p>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

            </div>
            <div className='full-width-section bg-white'>
                <Container fluid>
                    <Row>
                        <Col lg={5}>
                            <div className='form-box'>
                                <AvForm

                                >
                                    <AvField type="text" name="name" label="Name" required />
                                    <AvField type="email" name="email" label="Email" required />
                                    <AvField type="text" name="subject" label="Subject" required />
                                    <AvField type="textarea" name="message" label="Message" required />

                                    <FormGroup>
                                        <Button type="submit" className="common-btn mt-3">Submit</Button>
                                    </FormGroup>
                                </AvForm>
                            </div>
                        </Col>
                        <Col lg={7}>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3510.3090410867094!2d76.93661781440096!3d28.379732402229685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d3e8c40000001%3A0x1a8a2776bca625c!2sDonaldson%20India%20Filter%20Systems%20Private%20Limited!5e0!3m2!1sen!2sin!4v1672036482521!5m2!1sen!2sin" style={{width:'100%',height:'100%'}}  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
            <Clients />
            </div>
        </>
    )
}

